import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';

/**
 * BlankLanding component serves as a placeholder page for menu items
 * that don't have implemented functionality yet.
 */
const BlankLanding = () => {
  const location = useLocation();
  
  // Extract page name from path with section awareness
  const pagePath = location.pathname.substring(1);
  
  // Determine if it's an input or management page
  const isInputPage = pagePath.includes('inputs');
  const isManagementPage = pagePath.includes('management');
  
  // Extract the base name (remove -inputs or -management suffix)
  let baseName = pagePath;
  if (isInputPage) {
    baseName = pagePath.replace('-inputs', '');
  } else if (isManagementPage) {
    baseName = pagePath.replace('-management', '');
  }
  
  // Format the page name (capitalize first letter)
  const formattedPageName = baseName.charAt(0).toUpperCase() + baseName.slice(1);
  
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            {formattedPageName} {isInputPage ? 'Input' : isManagementPage ? 'Management' : ''}
          </Typography>
          <Typography variant="body1" paragraph>
            This page is under development. The {formattedPageName.toLowerCase()} {isInputPage ? 'input' : isManagementPage ? 'management' : ''} functionality 
            will be available in a future update.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Please check back later for updates or contact the development team for more information.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default BlankLanding;
